(() => {
  if (customElements.get('woofsocks-cart-photos')) return;
  class CartPhotos extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.button = this.querySelector('[data-photo-preview-toggle]');
      this.panel = this.querySelector('[data-photo-previews]');
      this.status = this.querySelector('[data-photo-preview-status]');
      this.button.addEventListener('click', () => this.toggle(), { signal: this.controller.signal });
    }
    disconnectedCallback() { this.controller?.abort(); this.dialog?.remove(); }
    async toggle() {
      if (this.loading) return;
      if (!this.panel.hidden) { this.panel.hidden = true; this.button.setAttribute('aria-expanded', 'false'); return; }
      this.panel.hidden = false; this.button.setAttribute('aria-expanded', 'true');
      if (this.loaded) return;
      this.loading = true; this.button.disabled = true; this.status.textContent = 'Loading your photo preview…';
      try {
        const cartResponse = await fetch('/cart.js', { cache: 'no-store', headers: { Accept: 'application/json' }, signal: this.controller.signal });
        if (!cartResponse.ok) throw new Error('cart unavailable');
        const cart = await cartResponse.json();
        if (!cart.items?.some(item => item.properties?._ws_photo_receipt === this.dataset.receipt)) throw new Error('attachment not in current cart');
        const nonce = [...crypto.getRandomValues(new Uint8Array(24))].map(v => v.toString(16).padStart(2, '0')).join('');
        const response = await fetch(`/apps/woofsocks-photos/previews?nonce=${nonce}`, {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ receipt: this.dataset.receipt, cart_key: cart.token }), signal: this.controller.signal,
        });
        const result = await response.json();
        if (!response.ok || !Array.isArray(result.photos) || !result.photos.length || result.photos.length > 4 || result.photos.some(photo => typeof photo.preview !== 'string' || !/^data:image\/jpeg;base64,/.test(photo.preview))) throw new Error(`preview response ${response.status}: ${String(result.error || 'invalid thumbnail').slice(0,120)}`);
        this.panel.replaceChildren();
        result.photos.forEach((photo, index) => {
          const button = document.createElement('button'), image = document.createElement('img');
          button.type = 'button'; button.className = 'ws-cart-photo__thumb'; button.setAttribute('aria-label', `Preview pet photo ${index + 1}`);
          image.src = photo.preview; image.alt = `Your pet photo ${index + 1}`; image.width = 80; image.height = 80;
          button.append(image); button.addEventListener('click', () => this.enlarge(photo.preview, index, button), { signal: this.controller.signal }); this.panel.append(button);
        });
        this.loaded = true; this.status.textContent = 'Your uploaded photo previews. Select a photo to enlarge.';
      } catch (error) {
        if (error.name !== 'AbortError') console.warn('WoofSocks photo preview:', error.message);
        if (error.name !== 'AbortError') this.status.textContent = 'Preview could not load. Try again, or contact us before ordering to confirm your photo.';
      } finally { this.loading = false; if (this.isConnected) this.button.disabled = false; }
    }
    enlarge(source, index, opener) {
      this.dialog?.remove();
      const dialog = document.createElement('dialog'), image = document.createElement('img'), close = document.createElement('button');
      dialog.className = 'ws-cart-photo__dialog'; dialog.setAttribute('aria-label', `Pet photo ${index + 1} preview`);
      image.src = source; image.alt = `Your pet photo ${index + 1}`; close.type = 'button'; close.textContent = 'Close photo preview';
      close.addEventListener('click', () => dialog.close()); dialog.addEventListener('close', () => opener.focus());
      dialog.append(image, close); document.body.append(dialog); this.dialog = dialog; dialog.showModal();
    }
  }
  customElements.define('woofsocks-cart-photos', CartPhotos);
})();
